import { Typography } from '@mui/material'

import CloudflareImage from '@ecm/ui/element/CloudflareImage'
import GradientBox from '@ecm/ui/element/GradientBox'
import MainContainer from '@ecm/ui/element/MainContainer'

const TrustBanner = ({ text }: { text: string }) => (
  <MainContainer>
    <GradientBox
      mb="3em"
      p={{ lg: '2.5em 5em', sm: '2.5em', xs: '1.5em' }}
      display="grid"
      gap={{ md: '3em', sm: '2.5em', xs: '1.5em' }}
      gridTemplateColumns={{ md: '100px auto', xs: '50px auto' }}
      alignItems="center"
      maxWidth="lg"
    >
      <CloudflareImage src="/images/icon/lightbulb-white.svg" height={75} width={55} />
      <Typography variant="h6" component="p" m="0">
        {text}
      </Typography>
    </GradientBox>
  </MainContainer>
)

export default TrustBanner
